import React from 'react';
import { observer } from 'mobx-react-lite';
import { Button, colors, RadioButton } from '@insurancemenu/imenu-components-lib';
import { useRootStore } from 'store/rootStore';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { ProductType } from 'types/enrollmentService';
import { createStyles } from './styles';

interface Props {
  productLineId: ProductLineId;
}

const RenewalItemSelectBar = observer(({ productLineId }: Props): JSX.Element => {
  // Mobx store
  const rootStore = useRootStore();
  const {
    proposalItemsStore: { setCartItemValue, isProductLineDontProvide, renewAsIsSelected },
  } = rootStore;

  function onChange(): void {
    setCartItemValue(productLineId, ProductType.RENEW, true);
  }

  function onUndo(): void {
    setCartItemValue(productLineId, ProductType.RENEW, false);
  }

  const isButtonChecked = renewAsIsSelected(productLineId);

  const classes = createStyles();
  return (
    <div className={classes.actionBlock}>
      <RadioButton
        value={ProductType.RENEW}
        checked={isButtonChecked}
        label=""
        id="select_renew"
        className={classes.radioButton}
        onChange={onChange}
      />
      {isButtonChecked ? (
        <Button color="primary" size="large" type="opaque">
          Plan Renew As Is
        </Button>
      ) : (
        <Button color={isProductLineDontProvide(productLineId) ? 'default' : 'primary'} size="large" onClick={onChange}>
          Renew As Is
        </Button>
      )}
      {isButtonChecked && (
        <Button onClick={onUndo} type="text" color="custom" customColor={colors.red[500]} className={classes.undoBtn}>
          UNDO
        </Button>
      )}
    </div>
  );
});

export default RenewalItemSelectBar;
